import {
  Identifiable,
  Planzone,
  ProjectListingConfiguration,
} from "@planzone/dto";
import { HttpClient, HttpMethods } from "@planzone/services";

function getDefaultConf(
  areProjectStatsHiddenInProjectListing: boolean,
): ProjectListingConfiguration {
  return [
    {
      name: "Admin",
      roles: ["pz_admin"],
      elements: [
        {
          type: "column",
          label: {
            fr: "",
            en: "",
          },
          key: "zone",
          elements: [],
        },
        {
          type: "column",
          label: {
            fr: "",
            en: "",
          },
          key: "weather",
          elements: [],
        },
        {
          type: "column",
          label: {
            fr: "",
            en: "",
          },
          key: "strategicScore",
          elements: [],
        },
        {
          type: "column",
          label: {
            fr: "",
            en: "",
          },
          key: "projectManagers",
          elements: [],
        },
        {
          type: "section",
          label: {
            fr: "Suivi de l'activité",
            en: "Activity monitoring",
          },
          key: "activityMonitoring",
          elements: [
            {
              type: "column",
              label: {
                fr: "",
                en: "",
              },
              key: "activityMonitoring_done",
              elements: [],
            },
            {
              type: "column",
              label: {
                fr: "",
                en: "",
              },
              key: "activityMonitoring_delayed",
              elements: [],
            },
            {
              type: "column",
              label: {
                fr: "",
                en: "",
              },
              key: "activityMonitoring_opened",
              elements: [],
            },
          ],
        },
        {
          type: "section",
          label: {
            fr: "Travail",
            en: "Work",
          },
          key: "workload",
          elements: [
            {
              type: "column",
              label: {
                fr: "",
                en: "",
              },
              key: "workload_allocatedTime",
              elements: [],
            },
            {
              type: "column",
              label: {
                fr: "",
                en: "",
              },
              key: "workload_spentTime",
              elements: [],
            },
            {
              type: "column",
              label: {
                fr: "",
                en: "",
              },
              key: "workload_remainingWork",
              elements: [],
            },
          ],
        },
        {
          type: "section",
          label: {
            fr: "Budget",
            en: "Budget",
          },
          key: "budget",
          elements: [
            {
              type: "column",
              label: {
                fr: "",
                en: "",
              },
              key: "budget_allocatedBudget",
              elements: [],
            },
            {
              type: "column",
              label: {
                fr: "",
                en: "",
              },
              key: "budget_plannedBudget",
              elements: [],
            },
            {
              type: "column",
              label: {
                fr: "",
                en: "",
              },
              key: "budget_realCosts",
              elements: [],
            },
            {
              type: "column",
              label: {
                fr: "",
                en: "",
              },
              key: "budget_plannedMargin",
              elements: [],
            },
            {
              type: "column",
              label: {
                fr: "",
                en: "",
              },
              key: "budget_realMargin",
              elements: [],
            },
            {
              type: "column",
              label: {
                fr: "",
                en: "",
              },
              key: "budget_acquiredValue",
              elements: [],
            },
          ],
        },
      ],
    },
    {
      name: "Others",
      roles: ["pr_manager"],
      elements: [
        {
          type: "column",
          label: {
            fr: "",
            en: "",
          },
          key: "weather",
          elements: [],
        },
        {
          type: "column",
          label: {
            fr: "",
            en: "",
          },
          key: "strategicScore",
          elements: [],
        },
        ...(!areProjectStatsHiddenInProjectListing
          ? ([
              {
                type: "section",
                label: {
                  fr: "Suivi de l'activité",
                  en: "Activity monitoring",
                },
                key: "activityMonitoring",
                elements: [
                  {
                    type: "column",
                    label: {
                      fr: "",
                      en: "",
                    },
                    key: "activityMonitoring_done",
                    elements: [],
                  },
                  {
                    type: "column",
                    label: {
                      fr: "",
                      en: "",
                    },
                    key: "activityMonitoring_delayed",
                    elements: [],
                  },
                  {
                    type: "column",
                    label: {
                      fr: "",
                      en: "",
                    },
                    key: "activityMonitoring_opened",
                    elements: [],
                  },
                ],
              },
              {
                type: "section",
                label: {
                  fr: "Travail",
                  en: "Work",
                },
                key: "workload",
                elements: [
                  {
                    type: "column",
                    label: {
                      fr: "",
                      en: "",
                    },
                    key: "workload_allocatedTime",
                    elements: [],
                  },
                  {
                    type: "column",
                    label: {
                      fr: "",
                      en: "",
                    },
                    key: "workload_spentTime",
                    elements: [],
                  },
                  {
                    type: "column",
                    label: {
                      fr: "",
                      en: "",
                    },
                    key: "workload_remainingWork",
                    elements: [],
                  },
                ],
              },
            ] as any)
          : []),
      ],
    },
  ];
}

function getProjectDetailsConfiguration(httpClient: HttpClient) {
  return (planzone: Identifiable<Planzone>) =>
    httpClient
      .sendHttpRequest<Identifiable<Planzone>>({
        endpoint: `/planzones/${planzone.uuid}`,
        method: HttpMethods.GET,
      })
      .then(({ data, settings }) =>
        !!data.projectDetailsConfiguration
          ? JSON.parse(data.projectDetailsConfiguration)
          : getDefaultConf(
              settings["areProjectStatsHiddenInProjectListing"] === "true",
            ),
      );
}

export { getProjectDetailsConfiguration };
